import React, { useCallback, useEffect, useState } from "react";
import {
  TextField,
  MenuItem,
  Box,
  Typography,
  Button,
  FormControl,
  Autocomplete,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup"; // For validation
import { toast } from "react-toastify";
import { getAllAgentsService } from "../../services/agentService";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../utils/apiUtils";
import debounce from "lodash/debounce";
import {
  checkCustomerGroupService,
  createGroupService,
} from "../../services/groupService";

// Validation Schema
const LoanSchema = Yup.object().shape({
  groupName: Yup.string(),
  groupLeaderPhoneNumber: Yup.string(),
  agent: Yup.string().required("Agent is required"),
  loanAmount: Yup.number().required("Loan Amount is required"),
  frequency: Yup.string().required("Frequency is required"),
  startDate: Yup.date().required("Start Date is required"),
  endDate: Yup.date().required("End Date is required"),
  processingFee: Yup.number().required("Processing Fees is required"),
  interestAmount: Yup.number().required("Interest Amount is required"),
  loanTenure: Yup.string().required("Loan Tenure is required"),
  amountToBePaidBy: Yup.string().required("Amount to be paid by is required"),
  disbursedAmount: Yup.number().required("Disbursed Amount is required"),
  collectionAmount: Yup.number().required("Collection Amount is required"),
  interest: Yup.number().required("Interest is required"),
  collectionDay: Yup.string(),
  pigmyPlan: Yup.string(),
  penaltyAmount: Yup.number(),
  // customers: Yup.array()
  //   .min(1, "Please select at least one customer")
  //   .required("Customers are required"),
});

const CreateGroup = () => {
  const [selectedCustomers, setSelectedCustomers] = useState();
  const [agents, setAgents] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const navigate = useNavigate(); // Fetch customers data
  const token = sessionStorage.getItem("accessToken");
  const [isSubmit, setIsSubmit] = useState(false);

  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService(0, 50);
      setAgents(agents?.agentsWithPhoneContacts);
    } catch (err) {
      toast.error(err.message);
    }
  };
  // const fetchCustomers = async () => {
  //   // Mock customer fetching or real API call
  //   const mockCustomers = [
  //     { _id: "1", name: "Customer 1" },
  //     { _id: "2", name: "Customer 2" },
  //     { _id: "3", name: "Customer 3" },
  //   ];
  // };
  const fetchOptions = async (query) => {
    if (!query) {
      setOptions([]); // Clear options if query is empty
      return;
    }
    setLoading(true);
    const isGroupCustomer = true;
    try {
      const response = await axios.get(`${API_URL}/customer/search-customer`, {
        params: { query, isGroupCustomer },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOptions(response.data || []); // Set options or empty array
    } catch (error) {
      console.error("Error fetching options:", error);
      setOptions([]); // Clear options on error
    }
    setLoading(false);
  };

  const debouncedFetchOptions = useCallback(
    debounce((query) => {
      fetchOptions(query);
    }, 1000),
    []
  );
  const calculateCollectionAmount = (values, tenure) => {
    if (values.loanAmount) {
      const collectionAmount = values.loanAmount / tenure;

      return { amount: Math.round(collectionAmount) }; // Round to the nearest whole number
    }
    return { amount: 0 }; // Return 0 if loanAmount is not provided
  };
  const calculateInterestAndCollection = (values) => {
    if (values.loanAmount) {
      const totalAmount = (values.loanAmount * values.interest) / 100;
      const totalInterestAmount = totalAmount * values.loanTenure;
      const collectionAmount =
        (totalInterestAmount + values.loanAmount) / values.loanTenure;
      return { amount: Math.round(collectionAmount), totalInterestAmount };
    }
  };
  const calculateInterest = (values) => {
    const collectionAmount = (values.loanAmount * values.interest) / 100;
    // const collectionAmount = InterestAmount / values.loanTenure;
    return { amount: Math.round(collectionAmount) };
  };

  const calculateEndDate = (values, frequency) => {
    let startDate = new Date();
    let endDate = new Date(startDate); // Copy startDate
    console.log(endDate);
    console.log(startDate);

    if (frequency === "daily") {
      endDate.setDate(startDate.getDate() + values?.loanTenure);
    } else if (frequency === "weekly") {
      endDate.setDate(startDate.getDate() + values?.loanTenure * 7);
    } else if (frequency === "monthly") {
      endDate.setMonth(startDate.getMonth() + values?.loanTenure);
      if (startDate.getDate() !== endDate.getDate()) {
        endDate.setDate(startDate.getDate());
      }
    }

    return {
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
    };
  };

  function calculateMonthsFromWeeks(weeks) {
    const weeksPerMonth = 4.345; // Approximate number of weeks in a month
    const months = weeks / weeksPerMonth;
    return Math.round(months); // Returns result rounded to the nearest whole number
  }
  function calculateMonthsFromDays(days) {
    const daysPerMonth = 30.44; // Average number of days in a month
    const months = days / daysPerMonth;
    return Math.round(months); // Returns result rounded to the nearest whole number
  }

  const calculateInterestChange = (interest, values) => {
    const months = calculateMonthsFromWeeks(values.loanTenure);
    const collectionAmount = (values.loanAmount * interest) / 100;
    const interestAmount = collectionAmount * months;
    const disbursedAmount = values.loanAmount - interestAmount;
    return { interestAmount: interestAmount, disbursedAmount: disbursedAmount };
  };
  const calculateInterestAndDisbursedAmount = (values, type) => {
    let months;
    if (type === "weekly") {
      console.log("week");
      months = calculateMonthsFromWeeks(values.loanTenure);
    } else if (type === "daily") {
      console.log("daily");
      months = calculateMonthsFromDays(values.loanTenure);
    }

    const collectionAmount = (values.loanAmount * values.interest) / 100;
    const interestAmount = collectionAmount * months;
    const disbursedAmount = values.loanAmount - interestAmount;
    return { interestAmount: interestAmount, disbursedAmount: disbursedAmount };
  };

  const handleSubmit = async (values) => {
    try {
      if (
        (values?.frequency === "daily" || values?.frequency === "weekly") &&
        values?.penaltyAmount === 0
      ) {
        toast.error("Penalty Amount Should Be Greater Than O");
      } else {
        setIsSubmit(true);
        await createGroupService(values);
        toast.success("Group Created successfully!");
        navigate("/group");
      }
      // Include user ID with the form values
      // const payload = { ...values, user: "userId" }; // Adjust as per your context
    } catch (error) {
      setIsSubmit(false);
      console.log(error);
      toast.error(error);
    }
  };

  const handleStartDate = (values, date) => {
    let startDate = new Date(date);
    let endDate = new Date(startDate); // Copy startDate

    if (values?.frequency === "daily") {
      endDate.setDate(startDate.getDate() + Number(values?.loanTenure));
    } else if (values?.frequency === "weekly") {
      endDate.setDate(startDate.getDate() + Number(values?.loanTenure) * 7);
    } else if (values?.frequency === "monthly") {
      console.log(endDate);
      console.log(startDate.getMonth() + Number(values?.loanTenure));
      endDate.setMonth(startDate.getMonth() + Number(values?.loanTenure));
      console.log(endDate);
      if (startDate.getDate() !== endDate.getDate()) {
        endDate.setDate(startDate.getDate());
      }
    }

    return {
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
    };
  };

  useEffect(() => {
    fetchAgents();
    console.log();
  }, []);

  return (
    <Box sx={{ p: 4, backgroundColor: "#fff", borderRadius: "8px" }}>
      <Typography variant="h5" mb={2}>
        Create Group
      </Typography>
      <Formik
        initialValues={{
          groupName: "",
          groupLeaderPhoneNumber: "",
          agent: "",
          loanAmount: "",
          frequency: "",
          startDate: null,
          endDate: null,
          processingFee: 0,
          interestAmount: 0,
          loanTenure: "",
          amountToBePaidBy: "",
          disbursedAmount: "",
          collectionAmount: "",
          interest: 5,
          collectionDay: "",
          pigmyPlan: "",
          penaltyAmount: 0,
          customers: [], // Initialize customers as an empty array
        }}
        validationSchema={LoanSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, setFieldValue, errors, touched }) => (
          <Form>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: 2,
              }}
            >
              <Box>
                <Typography>Group Name *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="groupName"
                  fullWidth
                  error={touched.groupName && Boolean(errors.groupName)}
                  helperText={touched.groupName && errors.groupName}
                  required
                  // inputProps={{
                  //   onInput: (e) => {
                  //     e.target.value = e.target.value.replace(
                  //       /[^a-zA-Z\s]/g,
                  //       ""
                  //     ); // Allow only alphabets and spaces
                  //   },
                  // }}
                />
              </Box>
              <Box>
                <Typography>Group Leader Phone Number *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="groupLeaderPhoneNumber"
                  fullWidth
                  error={
                    touched.groupLeaderPhoneNumber &&
                    Boolean(errors.groupLeaderPhoneNumber)
                  }
                  helperText={
                    touched.groupLeaderPhoneNumber &&
                    errors.groupLeaderPhoneNumber
                  }
                  inputProps={{
                    maxLength: 10, // Limits the input to 10 characters
                    inputMode: "numeric", // Brings up a numeric keyboard on mobile devices
                    style: { appearance: "textfield" }, // Remove arrows for most browsers
                  }}
                  sx={{
                    "& input": {
                      MozAppearance: "textfield", // Remove arrows for Firefox
                    },
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 10); // Allow only numbers and limit to 10 digits
                  }}
                  required
                />
              </Box>
              {/* Agent Field */}
              <Box>
                <Typography>Agent *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="agent"
                  select
                  fullWidth
                  error={touched.agent && Boolean(errors.agent)}
                  helperText={touched.agent && errors.agent}
                  required
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        style: {
                          maxHeight: 200, // Set the maximum height for the dropdown
                          overflowY: "auto", // Enable vertical scrolling
                        },
                      },
                    },
                  }}
                >
                  {agents.map((agent) => (
                    <MenuItem key={agent._id} value={agent._id}>
                      {agent.userName}
                    </MenuItem>
                  ))}
                </Field>
              </Box>

              {/* Loan Amount Field */}
              <Box>
                <Typography>Loan Amount *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="loanAmount"
                  type="number"
                  fullWidth
                  inputProps={{
                    min: 0, // Prevent negative numbers
                    step: 1, // Optional: Define step increment (if needed)
                    style: { appearance: "textfield" }, // Remove arrows for most browsers
                  }}
                  sx={{
                    "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                      {
                        appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                        margin: 0,
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield", // Remove arrows for Firefox
                    },
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault(); // Prevent minus sign and "e"
                    }
                  }}
                  error={touched.loanAmount && Boolean(errors.loanAmount)}
                  helperText={touched.loanAmount && errors.loanAmount}
                  required
                />
              </Box>

              {/* Loan Tenure Field */}
              <Box>
                <Typography>Loan Tenure *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="loanTenure"
                  type="number"
                  fullWidth
                  error={touched.loanTenure && Boolean(errors.loanTenure)}
                  helperText={touched.loanTenure && errors.loanTenure}
                  required
                  sx={{
                    "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                      {
                        appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                        margin: 0,
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield", // Remove arrows for Firefox
                    },
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault(); // Prevent minus sign and "e"
                    }
                  }}
                  onChange={(e) => {
                    handleChange(e);
                    const { amount } = calculateCollectionAmount(
                      values,
                      e.target.value
                    );
                    setFieldValue("collectionAmount", amount);
                  }}
                />
              </Box>

              {/* Frequency Field */}
              <Box>
                <Typography>Frequency *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="frequency"
                  select
                  fullWidth
                  error={touched.frequency && Boolean(errors.frequency)}
                  helperText={touched.frequency && errors.frequency}
                  required
                  onChange={(e) => {
                    handleChange(e);
                    const { startDate, endDate } = calculateEndDate(
                      values,
                      e.target.value
                    );
                    if (
                      e.target.value === "daily" ||
                      e.target.value === "weekly"
                    ) {
                      setFieldValue("amountToBePaidBy", "emi");
                      const { interestAmount, disbursedAmount } =
                        calculateInterestAndDisbursedAmount(
                          values,
                          e.target.value
                        );
                      console.log(interestAmount, disbursedAmount);
                      setFieldValue("interestAmount", interestAmount);
                      setFieldValue("disbursedAmount", disbursedAmount);
                    }
                    setFieldValue("startDate", startDate);
                    setFieldValue("endDate", endDate);
                  }}
                >
                  {/* <MenuItem value="daily">Daily</MenuItem> */}
                  <MenuItem value="weekly">Weekly</MenuItem>
                  <MenuItem value="monthly">Monthly</MenuItem>
                </Field>
              </Box>

              {/* Interest Field */}
              <Box>
                <Typography>Interest *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="interest"
                  type="number"
                  fullWidth
                  inputProps={{
                    min: 0, // Prevent negative numbers
                    step: "any", // Optional: Define step increment (if needed)
                    style: { appearance: "textfield" }, // Remove arrows for most browsers
                  }}
                  sx={{
                    "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                      {
                        appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                        margin: 0,
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield", // Remove arrows for Firefox
                    },
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault(); // Prevent minus sign and "e"
                    }
                  }}
                  onChange={(e) => {
                    handleChange(e);
                    const { interestAmount, disbursedAmount } =
                      calculateInterestChange(e.target.value, values);
                    console.log(interestAmount, disbursedAmount);
                    setFieldValue("interestAmount", interestAmount);
                    setFieldValue("disbursedAmount", disbursedAmount);
                    if (values.amountToBePaidBy === "interest") {
                      setFieldValue("collectionAmount", interestAmount);
                      const disbursedAmount =
                        values.loanAmount - interestAmount;
                      setFieldValue("disbursedAmount", disbursedAmount);
                    }
                  }}
                  error={touched.interest && Boolean(errors.interest)}
                  helperText={touched.interest && errors.interest}
                  required
                />
              </Box>

              {/* Amount to be Paid By Field */}
              <Box>
                <Typography>Amount to be Paid By *</Typography>
                <Field
                  as={TextField}
                  size="small"
                  name="amountToBePaidBy"
                  select
                  fullWidth
                  error={
                    touched.amountToBePaidBy && Boolean(errors.amountToBePaidBy)
                  }
                  helperText={
                    touched.amountToBePaidBy && errors.amountToBePaidBy
                  }
                  required
                  onChange={(e) => {
                    handleChange(e);
                    if (e.target.value === "interest") {
                      const { amount } = calculateInterest(values);
                      const disbursedAmount = values.loanAmount - amount;

                      setFieldValue("disbursedAmount", disbursedAmount);
                      setFieldValue("interestAmount", amount);
                      setFieldValue("collectionAmount", amount);
                    } else if (e.target.value === "interest+emi") {
                      const { amount, totalInterestAmount } =
                        calculateInterestAndCollection(values);
                      setFieldValue("interestAmount", totalInterestAmount);
                      setFieldValue("collectionAmount", amount);
                      setFieldValue("disbursedAmount", values.loanAmount);
                    } else {
                      const { amount } = calculateCollectionAmount(
                        values,
                        values.loanTenure
                      );
                      setFieldValue("collectionAmount", amount);
                    }
                  }}
                >
                  {values.frequency === "monthly"
                    ? [
                        <MenuItem key="interest" value="interest">
                          Interest
                        </MenuItem>,
                        <MenuItem key="interest+emi" value="interest+emi">
                          Interest + EMI
                        </MenuItem>,
                      ]
                    : [
                        <MenuItem key="emi" value="emi">
                          EMI
                        </MenuItem>,
                      ]}
                </Field>
              </Box>

              {/* Start Date Field */}
              <Box>
                <Typography>Start Date *</Typography>
                <Field
                  as={TextField}
                  name="startDate"
                  type="date"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  onChange={(e) => {
                    handleChange(e);
                    const { startDate, endDate } = handleStartDate(
                      values,
                      e.target.value
                    );
                    setFieldValue("startDate", startDate);
                    setFieldValue("endDate", endDate);
                  }}
                  error={touched.startDate && Boolean(errors.startDate)}
                  helperText={touched.startDate && errors.startDate}
                  required
                />
              </Box>

              {/* End Date Field */}
              <Box>
                <Typography>End Date *</Typography>
                <Field
                  as={TextField}
                  name="endDate"
                  type="date"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  error={touched.endDate && Boolean(errors.endDate)}
                  helperText={touched.endDate && errors.endDate}
                  required
                  InputProps={{
                    readOnly: true, // Makes the field read-only
                  }}
                />
              </Box>

              {/* Processing Fees Field */}
              <Box>
                <Typography>Processing Fees *</Typography>
                <Field
                  as={TextField}
                  name="processingFee"
                  type="number"
                  size="small"
                  fullWidth
                  error={touched.processingFee && Boolean(errors.processingFee)}
                  helperText={touched.processingFee && errors.processingFee}
                  required
                  inputProps={{
                    min: 0, // Prevent negative numbers
                    step: 1, // Optional: Define step increment (if needed)
                    style: { appearance: "textfield" }, // Remove arrows for most browsers
                  }}
                  sx={{
                    "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                      {
                        appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                        margin: 0,
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield", // Remove arrows for Firefox
                    },
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault(); // Prevent minus sign and "e"
                    }
                  }}
                />
              </Box>

              {/* Interest Amount Field */}
              <Box>
                <Typography>Interest Amount *</Typography>
                <Field
                  as={TextField}
                  name="interestAmount"
                  type="number"
                  size="small"
                  fullWidth
                  inputProps={{
                    min: 0, // Prevent negative numbers
                    step: 1, // Optional: Define step increment (if needed)
                    style: { appearance: "textfield" }, // Remove arrows for most browsers
                  }}
                  sx={{
                    "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                      {
                        appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                        margin: 0,
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield", // Remove arrows for Firefox
                    },
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault(); // Prevent minus sign and "e"
                    }
                  }}
                  error={
                    touched.interestAmount && Boolean(errors.interestAmount)
                  }
                  helperText={touched.interestAmount && errors.interestAmount}
                  required
                  InputProps={{
                    readOnly: true, // Makes the field read-only
                  }}
                />
              </Box>

              {/* Disbursed Amount Field */}
              <Box>
                <Typography>Disbursed Amount *</Typography>
                <Field
                  as={TextField}
                  name="disbursedAmount"
                  type="number"
                  size="small"
                  fullWidth
                  error={
                    touched.disbursedAmount && Boolean(errors.disbursedAmount)
                  }
                  helperText={touched.disbursedAmount && errors.disbursedAmount}
                  required
                  inputProps={{
                    min: 0, // Prevent negative numbers
                    step: 1, // Optional: Define step increment (if needed)
                    style: { appearance: "textfield" }, // Remove arrows for most browsers
                  }}
                  sx={{
                    "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                      {
                        appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                        margin: 0,
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield", // Remove arrows for Firefox
                    },
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault(); // Prevent minus sign and "e"
                    }
                  }}
                  InputProps={{
                    readOnly: true, // Makes the field read-only
                  }}
                />
              </Box>

              {/* Collection Amount Field */}
              <Box>
                <Typography>Collection Amount *</Typography>
                <Field
                  as={TextField}
                  name="collectionAmount"
                  type="number"
                  size="small"
                  fullWidth
                  error={
                    touched.collectionAmount && Boolean(errors.collectionAmount)
                  }
                  helperText={
                    touched.collectionAmount && errors.collectionAmount
                  }
                  required
                  inputProps={{
                    min: 0, // Prevent negative numbers
                    step: 1, // Optional: Define step increment (if needed)
                    style: { appearance: "textfield" }, // Remove arrows for most browsers
                  }}
                  sx={{
                    "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                      {
                        appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                        margin: 0,
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield", // Remove arrows for Firefox
                    },
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault(); // Prevent minus sign and "e"
                    }
                  }}
                  InputProps={{
                    readOnly: true, // Makes the field read-only
                  }}
                />
              </Box>
              {values.frequency === "weekly" ? (
                <>
                  {" "}
                  <Box>
                    <Typography>Collection Day *</Typography>
                    <Field
                      as={TextField}
                      size="small"
                      name="collectionDay"
                      select
                      fullWidth
                      error={
                        touched.collectionDay && Boolean(errors.collectionDay)
                      }
                      helperText={touched.collectionDay && errors.collectionDay}
                      required
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    >
                      <MenuItem value="monday">Monday</MenuItem>
                      <MenuItem value="tuesday">Tuesday</MenuItem>
                      <MenuItem value="wednesday">Wednesday</MenuItem>
                      <MenuItem value="thursday">Thursday</MenuItem>
                      <MenuItem value="friday">Friday</MenuItem>
                      <MenuItem value="saturday">Saturday</MenuItem>
                    </Field>
                  </Box>
                  <Box>
                    <Typography>Penalty Amount *</Typography>
                    <Field
                      as={TextField}
                      name="penaltyAmount"
                      type="number"
                      size="small"
                      fullWidth
                      inputProps={{
                        min: 0, // Prevent negative numbers
                        step: 1, // Optional: Define step increment (if needed)
                        style: { appearance: "textfield" }, // Remove arrows for most browsers
                      }}
                      sx={{
                        "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                          {
                            appearance: "none", // Remove arrows for WebKit browsers (Chrome, Safari)
                            margin: 0,
                          },
                        "& input[type=number]": {
                          MozAppearance: "textfield", // Remove arrows for Firefox
                        },
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault(); // Prevent minus sign and "e"
                        }
                      }}
                      error={
                        touched.penaltyAmount && Boolean(errors.penaltyAmount)
                      }
                      helperText={touched.penaltyAmount && errors.penaltyAmount}
                    />
                  </Box>
                </>
              ) : null}
              <Box>
                <Typography>Pigmy Plan *</Typography>
                <Field
                  as={TextField}
                  name="pigmyPlan"
                  size="small"
                  select
                  fullWidth
                  error={touched.pigmyPlan && Boolean(errors.pigmyPlan)}
                  helperText={touched.pigmyPlan && errors.pigmyPlan}
                  required
                >
                  <MenuItem value="6">6 months</MenuItem>
                  <MenuItem value="12">12 months</MenuItem>
                  <MenuItem value="24">24 months</MenuItem>
                  <MenuItem value="36">36 months</MenuItem>
                </Field>
              </Box>
            </Box>

            {/* <Box mt={2}>
              <Typography variant="h6">Add Members</Typography>
            </Box> */}
            {/* Multiple Select Customer Field */}
            {/* Autocomplete Multiple Select Customer Field */}
            <Box
              gridColumn="span 4"
              sx={{
                display: "flex",
                justifyContent: "space-between", // Adjusts space between FormControl and Button
                alignItems: "center",
                mt: 2,
              }}
            >
              {/* <FormControl sx={{ width: "75%" }} size="small">
                <Autocomplete
                  multiple
                  id="customers"
                  options={options}
                  getOptionLabel={(option) =>
                    `${option.userName} (${option?.primaryPhone?.contactValue})` ||
                    ""
                  }
                  loading={loading}
                  loadingText="Loading customers..."
                  // Use values.customers to create a stable value list, independent of options
                  value={values.customers.map(
                    (id) =>
                      options.find((option) => option._id === id) ||
                      selectedCustomers.find((option) => option._id === id) || {
                        _id: id,
                        userName: "",
                        primaryPhone: { contactValue: "" },
                      }
                  )}
                  onInputChange={(event, newInputValue) => {
                    if (event && event.type === "change") {
                      debouncedFetchOptions(newInputValue);
                    }
                  }}
                  onChange={(event, selectedCustomers) => {
                    const selectedIds = selectedCustomers.map(
                      (customer) => customer?._id
                    );
                    setFieldValue("customers", selectedIds);
                    // Update the list of fully selected customer objects for stability
                    setSelectedCustomers(selectedCustomers);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Customers"
                      size="small"
                      error={touched.customers && Boolean(errors.customers)}
                      helperText={touched.customers && errors.customers}
                    />
                  )}
                />
              </FormControl> */}
              <FormControl sx={{ width: "75%" }} size="small">
                <Autocomplete
                  multiple
                  id="customers"
                  options={options}
                  getOptionLabel={(option) =>
                    `${option.userName} (${option?.primaryPhone?.contactValue})` ||
                    ""
                  }
                  loading={loading}
                  loadingText="Loading customers..."
                  value={values.customers.map(
                    (id) =>
                      options.find((option) => option._id === id) ||
                      selectedCustomers.find((option) => option._id === id) || {
                        _id: id,
                        userName: "",
                        primaryPhone: { contactValue: "" },
                      }
                  )}
                  onInputChange={(event, newInputValue) => {
                    if (event && event.type === "change") {
                      debouncedFetchOptions(newInputValue);
                    }
                  }}
                  onChange={async (event, selectedCustomers) => {
                    const selectedIds = [];
                    const validCustomers = [];

                    for (const customer of selectedCustomers) {
                      try {
                        // Call API to check if customer is part of another group
                        const response = await checkCustomerGroupService(
                          customer._id
                        );
                        console.log("response", response);
                        // If the API call is successful, add the customer to the valid list
                        validCustomers.push(customer);
                        selectedIds.push(customer._id);
                      } catch (error) {
                        console.log(error);
                        // If API returns 404, show toast and skip this customer
                        if (error.response && error.response.status === 403) {
                          toast.error(
                            `${customer.userName} is already part of another group!`
                          );
                        } else {
                          // Handle other errors
                          toast.error(`${customer.userName} ${error}`);
                        }
                      }
                    }

                    // Update Formik values and the selected customers state
                    setFieldValue("customers", selectedIds);
                    setSelectedCustomers(validCustomers);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Customers"
                      size="small"
                      error={touched.customers && Boolean(errors.customers)}
                      helperText={touched.customers && errors.customers}
                    />
                  )}
                />
              </FormControl>
            </Box>

            <Box mt={4}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmit}
              >
                Submit
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default CreateGroup;
